import {
  riskLabels,
  ShopifyRiskAssessmentResult,
} from "@redotech/redo-fulfillment-group-common/shopify-fulfillment-schemas";
import { fgFilterEntries } from "@redotech/redo-fulfillment-operations-common/views/fulfillment/fg-filter-catalog";
import StoreIcon from "@redotech/redo-icons/building-01.svg";
import { ArrayStringFilterOperator } from "@redotech/redo-views-common/advanced-filters/array-string-filter";
import { ArrayStringTableFilter } from "@redotech/redo-web/advanced-filters/advanced-filter";

const entry = fgFilterEntries.fraudRisk;

export const FraudRiskFilter = (): ArrayStringTableFilter => ({
  type: entry.type,
  itemLabel: "risk",
  operators: [...entry.operators],
  data: {
    name: entry.name,
    type: entry.type,
    value: [],
    operator: ArrayStringFilterOperator.ANY_OF,
  },
  Icon: StoreIcon,
  values: [...entry.staticValues],
  dbSearch: false,
  display: (item: string) => {
    return riskLabels[item as ShopifyRiskAssessmentResult];
  },
  displayName: entry.displayName,
});
